import * as React from 'react';

type Shape = Record<string, unknown>;
type GetInputType = (field: any, key: string) => string;

const formatDateToIsoDate = (value: Date) => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export function useFormDateSerializer(shape: Shape, getInputType: GetInputType) {
  return React.useCallback(
    (data: Record<string, unknown>) => {
      const entries = Object.entries(data).map(([key, value]) => {
        const field = (shape as any)[key];
        if (!field) return [key, value];

        const inputType = getInputType(field, key);

        if (inputType === 'date') {
          if (value instanceof Date) {
            return [key, formatDateToIsoDate(value)];
          }

          if (typeof value === 'string') {
            return [key, value];
          }

          return [key, value ?? null];
        }

        if (inputType === 'datetime') {
          if (value instanceof Date) {
            return [key, value.toISOString()];
          }

          if (typeof value === 'string') {
            return [key, value];
          }

          return [key, value ?? null];
        }

        return [key, value];
      });

      return Object.fromEntries(entries);
    },
    [getInputType, shape]
  );
}

export type SerializeFormData = ReturnType<typeof useFormDateSerializer>;

